import React from "react";
import "./Compliance.css";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

// Partner Logos
import sibLogo from "../../assets/images/SIB.jpeg";
import muthootLogo from "../../assets/images/muthoot.jpeg";
import vivritiLogo from "../../assets/images/vcl.jpg";
import ratnaafinLogo from "../../assets/images/ratnaafin.jpg";
import hindonLogo from "../../assets/images/hindon.jpeg";
import niyoginLogo from "../../assets/images/Niyogin.jpg";
import ramaiahLogo from "../../assets/images/ramaiah.jpeg";
import kaunshyaLogo from "../../assets/images/Kaunshya.jpg";
import AFPLLogo from "../../assets/images/Jupiter.jpeg";
import stplLogo from "../../assets/images/STPL.jpeg";
import filoansLogo from "../../assets/images/filoans.jpg";
import royalLogo from "../../assets/images/royaliltd.jpg";
import getvantageLogo from "../../assets/images/getvantage.jpeg";
import sharpLogo from "../../assets/images/sharpfin.jpeg";
import i2iLogo from "../../assets/images/i2i.jpeg";

interface Partner {
  image: string;
  title: string;
  content: React.ReactNode;
}

const Compliance: React.FC = () => {
  const partners: Partner[] = [
    {
      image: sibLogo,
      title: "South Indian Bank Logo",
      content: (
        <>
          <h5>South Indian Bank's Nodal Officer</h5>

          <p>
            Mr Shine Kappen,
												Assistant General Manager - Customer Relations, South Indian
												Bank Ltd. Head Office T.B Road, Mission Quarters, Thrissur
												680001,Kerala, India. Email: nodalofficer@sib.bank.in Call:
												0487-2420020, Extn: 687
          </p>

          <ul>
            <li>
              <a
                href="https://www.southindianbank.bank.in/"
                target="_blank"
                rel="noreferrer"
              >
                WEBSITE
              </a>
            </li>

            <li>
              <a
                href="https://www.southindianbank.bank.in/about-us/privacy-policy"
                target="_blank"
                rel="noreferrer"
              >
                TERMS AND POLICY
              </a>
            </li>

            <li>
              <a
                href="https://www.southindianbank.bank.in/other-links/disclosures/digital-loans"
                target="_blank"
                rel="noreferrer"
              >
                Digital Lending Products & DLAs
              </a>
            </li>

            <li>
              <a
                href="https://www.southindianbank.bank.in/other-links/disclosure/lending-partners"
                target="_blank"
                rel="noreferrer"
              >
                Lending Service Providers & Digital Partnerships
              </a>
            </li>

            <li>
              <a
                href="https://www.southindianbank.bank.in/help-desk/customer-care"
                target="_blank"
                rel="noreferrer"
              >
                Customer Care
              </a>
            </li>

            <li>
              <a
                href="https://www.southindianbank.bank.in/help-desk/complaint-registration"
                target="_blank"
                rel="noreferrer"
              >
                Internal Grievance Redressal Mechanism
              </a>
            </li>

            <li>
              <a
                href="https://www.southindianbank.bank.in/userfiles/file/sib_nodal_officer_contact_details.pdf"
                target="_blank"
                rel="noreferrer"
              >
                Nodal Greivance Redressal Officers Details?
              </a>
            </li>

            <li>
              <a
                href="https://cms.rbi.org.in/cms/indexpage.html#eng"
                target="_blank"
                rel="noreferrer"
              >
                RBI's Compliant Management System (CMS)
              </a>
            </li>
          </ul>
        </>
      ),
    },

    {
      image: muthootLogo,
      title: "Muthoot Finance Logo",
      content: (
        <>
          <h5>Muthoot Finance Limited's Nodal Officer</h5>

          <p>
            Kiran G. (General Manager) Customer Grievance, Address: 2nd
												Floor, Muthoot Chambers, Opposite Saritha Theatre Complex,
												Banerji Road, Kochi 682 018, Kerala, India Email:
												businessloans@muthootgroup.com<br/>Phone: +91-1146697754 
          </p>

          <a
            href="https://www.muthootfinance.com/"
            target="_blank"
            rel="noreferrer"
          >
            WEBSITE
          </a>

          <br />

          <a
            href="https://www.muthootfinance.com/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            TERMS AND POLICY
          </a>
        </>
      ),
    },

    {
      image: vivritiLogo,
      title: "Vivriti Capital Logo",
      content: (
        <>
          <h5>Vivriti Capital Limited's Nodal Officer</h5>

          <p>
            Ajitkumar Menon - Nodal Officer , Address: Prestige Zackria
												Metropolitan, No.200/1-8, 2nd Floor, Block 1, Anna Salai,
												Chennai 600002, India Email:
												Grievanceredressal@vivriticapital.com<br/>Phone: +91 444007 4801 
          </p>

          <a
            href="https://www.vivriticapital.com/"
            target="_blank"
            rel="noreferrer"
          >
            WEBSITE
          </a>

          <br />

          <a
            href="https://www.vivriticapital.com/assets/files/digital-lending/Greivance%20Redressal%20Mechanism%20Nov23.pdf"
            target="_blank"
            rel="noreferrer"
          >
            TERMS AND POLICY
          </a>
        </>
      ),
    },

    {
      image: ratnaafinLogo,
      title: "Ratnaafin Logo",
      content: (
        <>
          <h5>Ratnaafin Capital Private Limited</h5>

          <p>
            Mr. Bhavesh Patel - Nodal Officer , Address: 402, Bhikaji
												Cama Bhawan Ring Road, Bhikaji Cama Place, Near Hyatt Hotel,
												New Delhi - 110066, Delhi, India Email:
												grievance@ratnaafin.com<br/>Phone: +91 9228173636
          </p>

          <a
            href="https://www.ratnaafin.com/"
            target="_blank"
            rel="noreferrer"
          >
            WEBSITE
          </a>

          <br />

          <a
            href="https://www.ratnaafin.com/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            TERMS AND POLICY
          </a>
        </>
      ),
    },
        {
      image: hindonLogo,
      title: "Hindon Mercantile Limited Logo",
      content: (
        <>
          <h5>Hindon's Nodal Officer</h5>

          <p>
            Savita Bhogra ,Grievance Redressal Officer, Address: 379-380
												, Aggarwal Cyber Plaza, 3rd Floor, NSP, Pitampura, New Delhi
												- 110034 Email: helpdesk@mufinfinance.com<br/>Phone: +91
												9137504870
          </p>

          <a
            href="https://hindon.co/"
            target="_blank"
            rel="noreferrer"
          >
            WEBSITE
          </a>

          <br />

          <a
            href="https://hindon.co/wp-content/uploads/2022/09/Terms_and_condition.pdf"
            target="_blank"
            rel="noreferrer"
          >
            TERMS AND POLICY
          </a>
        </>
      ),
    },

    {
      image: niyoginLogo,
      title: "Niyogin Fintech Logo",
      content: (
        <>
          <h5>Niyogin Fintech Limited's Nodal Officer</h5>

          <p>
            Mr. Noorallah Charania - Chief Operating Officer , Address:
												Neelkanth Corporate IT Park, 311/312, 3 rd Floor, Kirol
												Road, Vidyavihar(W), Mumbai - 400086 Email:
												noorallah.charania@niyogin.in<br/>Phone: 18002660266 
          </p>

          <a
            href="https://www.niyogin.com"
            target="_blank"
            rel="noreferrer"
          >
            WEBSITE
          </a>

          <br />

          <a
            href="https://www.niyogin.com/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            TERMS AND POLICY
          </a>
        </>
      ),
    },

    {
      image: ramaiahLogo,
      title: "Ramaiah Capital Logo",
      content: (
        <>
          <h5>Ramaiah Capital's Nodal Officer</h5>

          <p>
            Sri.Pradeep Vaddarse, Assistant General Manager, Address:
												Ramaiah Capital Private Limited, No 4/A/"Rashma" 80 feet
												Road, Ashwathnagar, RMV II Stage Bengaluru- 560094 Email:
												complaints@ramaiahcapital.com<br/>Phone: 8023529708/09 
          </p>

          <a
            href="https://ramaiahcapital.com/"
            target="_blank"
            rel="noreferrer"
          >
            WEBSITE
          </a>

          <br />

          <a
            href="https://ramaiahcapital.com/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            TERMS AND POLICY
          </a>
        </>
      ),
    },

    {
      image: kaunshyaLogo,
      title: "Kaunshya Capital Logo",
      content: (
        <>
          <h5>Kaunshya Investments Private Limited</h5>

          <p>
            Mr. Raman Agarwal - Nodal Officer , Address: No. 10/1,
												Lakshmi Narayana Complex, 4th Floor Palace Road, Bangalore,
												Bangalore, Karnataka, India, 560052 Email:
												compliance@finsall.com<br/>Phone: 18005705797 
          </p>

          <a
            href="https://kaunshyacapital.com/"
            target="_blank"
            rel="noreferrer"
          >
            WEBSITE
          </a>

          <br />

          <a
            href="https://kaunshyacapital.com/index.php/help"
            target="_blank"
            rel="noreferrer"
          >
            TERMS AND POLICY
          </a>

          <a
            href="https://v1.finsall.com/static/vendor/grievance_redressal.pdf"
            target="_blank"
            rel="noreferrer"
          >
            COMPLIANT
          </a>
        </>
      ),
    },

    {
      image: AFPLLogo,
      title: "AFPL Logo",
      content: (
        <>
          <h5>AMICA FINANCE PRIVATE LIMITED's Nodal Officer</h5>

          <p>
            Sandeep Raj, Address: 3rd floor, Viraj Buildings, SV Road,
												Khar West, Mumbai 400052, Maharashtra, India Email:
												compliance@jupiter.credit<br/>Phone: N/A 
          </p>

          <a
            href="https://www.jupiter.credit/"
            target="_blank"
            rel="noreferrer"
          >
            WEBSITE
          </a>

          <br />

          <a
            href="https://www.jupiter.credit/static/media/privacy-policy.d42eecee515074773178.pdf"
            target="_blank"
            rel="noreferrer"
          >
            TERMS AND POLICY
          </a>
        </>
      ),
    },

    {
      image: stplLogo,
      title: "STPL Logo",
      content: (
        <>
          <h5>STPL's Nodal Officer</h5>

          <p>
            Mr. Akshat Harlalka,Santram Transformers Private
												Limited,Ground Floor, AB-96, sector 1, Saltlake
												city,Kolkata-700091 <br/>Email:
												harlalka.akshat@gmail.com  <br/>Tel: 03379625299
          </p>

          <a
            href="https://stplfin.com/"
            target="_blank"
            rel="noreferrer"
          >
            WEBSITE
          </a>

          <br />

          <a
            href="https://stplfin.com/elementor-15947/"
            target="_blank"
            rel="noreferrer"
          >
            TERMS AND POLICY
          </a>
        </>
      ),
    },
        {
      image: filoansLogo,
      title: "Fi Loans Logo",
      content: (
        <>
          <h5>Stock Guardians (India) Private Limited (Fi Loans)'s Nodal Officer</h5>

          <p>
            Vinod Gunasekaran - Chief Operating Officer , Address: Stock
												Guardians (India) Private Limited, WeWork Enam Sambhav,
												C-20, G Block BKC, Bandra Kurla Complex, Bandra East, Mumbai
												- 400051, Maharashtra, India Email:
												nodal.gro@stockguardians.com<br/>Phone: 80-47485490 
          </p>

          <a
            href="https://www.stockguardian.in/"
            target="_blank"
            rel="noreferrer"
          >
            WEBSITE
          </a>

          <br />

          <a
            href="https://www.stockguardian.in/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            TERMS AND POLICY
          </a>
        </>
      ),
    },

    {
      image: royalLogo,
      title: "Royal Instalments Logo",
      content: (
        <>
          <h5>Royal Installment Limited's Nodal Officer</h5>

          <p>
            CA Nirav Vora,
												Address: Corporate Office: Office No., 302, 3rd Floor, Nahar
												Business Center, Nahar Amrit Shakti, Chandivali, Andheri
												East, Mumbai 400072 <br/>Email: cavoranirav@gmail.com
          </p>
        </>
      ),
    },

    {
      image: getvantageLogo,
      title: "GetVantage Logo",
      content: (
        <>
          <h5>GetGrowth Capital Private Limited's Nodal Officer</h5>

          <p>
            Mr. Shrikant Jadhav Address: 27th Floor, Sunshine Tower,
												Senapati Bagat Marg,Lower Parel, Mumbai - 400013 Email:
												care@getgrowthcapital.co<br/>Phone: 8108754954 
          </p>

          <a
            href="https://getgrowthcapital.co/"
            target="_blank"
            rel="noreferrer"
          >
            WEBSITE
          </a>

          <br />

          <a
            href="https://getgrowthcapital.co/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            TERMS AND POLICY
          </a>
        </>
      ),
    },

    {
      image: sharpLogo,
      title: "Sharp Financial Services Logo",
      content: (
        <>
          <h5>Sharp Financial Services Private Limited's Nodal Officer</h5>

          <p>
            VITTHAL K MANDAVKAR, CEO, Address: 4B/4, Industry Manor, ASM
												Marg, Prabhadevi, Mumbai - 400025 <br/>Email: ceo@sharpfinserv.in <br/>Phone:
												9702961999 
          </p>

          <a
            href="https://sharpfinance.co.in/"
            target="_blank"
            rel="noreferrer"
          >
            WEBSITE
          </a>

          <br />

          <a
            href="https://sharpfinance.co.in/privacy-policy.html"
            target="_blank"
            rel="noreferrer"
          >
            TERMS AND POLICY
          </a>
        </>
      ),
    },

    {
      image: i2iLogo,
      title: "i2i Funding Logo",
      content: (
        <>
          <h5>I2I's Nodal Officer</h5>

          <p>
            Tushita Rastogi, i2iFunding, Ground Floor, A-217, Sector 69,
												Noida, 201301 <br/>Email: investment@i2ifunding.com <br/>Tel:
												+91 97174 20307
          </p>

          <a
            href="https://www.i2ifunding.com/"
            target="_blank"
            rel="noreferrer"
          >
            WEBSITE
          </a>

          <br />

          <a
            href="https://www.i2ifunding.com/grievance-redressal-policy"
            target="_blank"
            rel="noreferrer"
          >
            TERMS AND POLICY
          </a>
        </>
      ),
    },
  ];

    const downloadPdf = () => {
    const link = document.createElement("a");
    link.href =
      // "https://finsall.s3.ap-south-1.amazonaws.com/files/dlg/dlg.pdf";
      "https://finsall-media.s3.ap-south-1.amazonaws.com/dlg/dlg.pdf";
    link.download = "dlg.pdf";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>

    <title>Finsall Regulatory and Compliance Information</title>
<meta
  name="description"
  content="Access Finsall compliance standards, regulatory disclosures and policy guidelines for transparent insurance premium financing operations."
/>

      <Header />

      <section className="compliance-top-strip"></section>

      <section className="compliance-partners-section">

        <div className="compliance-container">

          <h1 className="compliance-title">
            Compliance Information for Premium Financing
          </h1>

          <div className="compliance-grid">

            {partners.map((partner, index) => (

              <div
                key={index}
                className="partner-card"
              >

                <img
                  src={partner.image}
                  alt={partner.title}
                />

                <div className="partner-overlay">

                  <div className="partner-overlay-content">

                    {partner.content}

                  </div>

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* ==========================================
          FINSALL NODAL OFFICER
      ========================================== */}

      <section className="nodal-section">

        <div className="compliance-container">

          <div className="nodal-card">

            <h2>
              Finsall Nodal Officer Info
            </h2>

            <p>
              <strong>
                Name:
              </strong>
              {" "}
              Prabal Khanna
            </p>

            <p>
              <strong>
                Address:
              </strong>
              {" "}
              365 Shared Space,
              Third Floor,
              No. 379,
              5th Main Road,
              Sector 6,
              HSR Layout,
              Bengaluru,
              Karnataka - 560102
            </p>

            <p>
              <strong>
                Email:
              </strong>
              {" "}
              compliance@finsall.com
            </p>

            <p>
              <strong>
                Phone:
              </strong>
              {" "}
              18005705797
            </p>

            {/* <div className="nodal-divider"></div> */}

            <h3>
              Sachet Portal Link
            </h3>

            <p>
              The customer can, if deemed fit,
              lodge a complaint by clicking the
										link: <a
              href="https://sachet.rbi.org.in"
              target="_blank"
              rel="noreferrer"
            >
              https://sachet.rbi.org.in
            </a>
            </p>

            

            {/* <div className="nodal-divider"></div> */}

            <h3>
              RBI Complaint Management System (CMS) Link:
            </h3>

            <p>
              The customer may escalate
										grievance to the RBI Ombudsman via the CMS portal by clicking
										this link: <a
              href="https://cms.rbi.org.in"
              target="_blank"
              rel="noreferrer"
            >
              https://cms.rbi.org.in/cms/indexpage.html#eng
            </a>
            </p>

          </div>

        </div>

      </section>

      {/* ==========================================
          DLG SECTION
      ========================================== */}

      <section className="dlg-section">

        <div className="compliance-container">

          <div className="dlg-card">

            <h2>
              Disclosure pursuant to Guidelines
              on Default Loss Guarantee (DLG)
              in Digital Lending
            </h2>

            <button
  className="dlg-download-btn"
  onClick={downloadPdf}
>
  Download
</button>

          </div>

        </div>

      </section>

      <Footer />

    </>

  );
};

export default Compliance;